import { TZDate } from "@date-fns/tz";
import { Run } from "@shared/lib/database/query.types";
import { parseISO } from "date-fns";

export default function (runs: Array<Pick<Run, "start_at">>, timezone: string) {
  if (runs.length === 0) return null;

  const daysOfWeek = runs.reduce((acc, run) => {
    const dayOfWeek = new TZDate(parseISO(run.start_at), timezone).getDay();

    if (!acc[dayOfWeek]) {
      acc[dayOfWeek] = [dayOfWeek, 1];
    } else {
      acc[dayOfWeek][1]++;
    }

    return acc;
  }, [] as Array<[number, number]>);

  daysOfWeek.sort((a, b) => b[1] - a[1]);

  return daysOfWeek[0][0];
}
